const initialState = {
    recommendPayload: null,
    data: {},
    usersProfilePicData: [],
    inlineimageData: null,
    notifFavData: {},
    isLoading: false,
    attachmentData: {},
    isBack:false,
    prevData:[],
    seekerAttachments:[],
    recommendations:[],
    tabValue:null
};

const recommendReducer = (state = initialState, action) => {
    switch (action.type) {
        case "notificationdataloading":
            state = { ...state, isLoading: action.payload };
            return state;
        case "recommendPageData":
            state = { ...state, recommendPayload: action.payload };
            // console.log(action.payload,'check data')
            return state;
        case "notificationactiondata":
            state = { ...state, data: action.payload };
            return state;
        case "searchexpertProfilePicData":
            state = { ...state, usersProfilePicData: state.usersProfilePicData.concat(action.payload) };
            return state;
        case "getinlineimages":
            state = { ...state, inlineimageData: action.payload };
            return state;
        case "notificationfavouritedata":
            state = { ...state, recommendPayload: action.payload };
            state = { ...state, data: action.payload };
            return state;
        case "attachmentsdata":
            state = { ...state, attachmentData: action.payload };
            return state;
        case "isBackRecommend":
            state = { ...state, isBack: action.payload };
            return state;
        case 'preservePrevData':
            state = { ...state, prevData: action.payload };
            return state;
        case 'getSeekerAttachmentsInReccommend':
            state = {...state, seekerAttachments:action.payload}
            return state;
        case 'getRecommendationsData':
            state = {...state, recommendations:action.payload}
            return state;
        case 'getTabValue':
            state = {...state, tabValue:action.payload}
            return state;
        default:
            return state;
    }
};

export default recommendReducer;
